:host {
  display: block;
}

.lilu-cms-customer-tile {
  max-width: 267px;
  max-height: 286px;
  width: 100%;
  height: auto;
  a {
    text-decoration: none;
  }

  @include mobileFullWidth();

  ::slotted(img) {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  ::slotted(lilu-p) {
    padding: 20px 10px;
    text-align: center;
    background-color: var(--color-bleached-silk);
  }
}
